import styled from "styled-components";
import * as palette from "../../SCVariables";

export const Button = styled.button`
  padding: 15px;
  border: none;
  font-size: 15px;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  width: 100px;
  flex: 1;
  background: ${palette.mainOrange};
  color: ${palette.mainBlack};

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${palette.mainOrange};
    color: ${palette.mainWhite};
  }
`;
